import type { EpgDateExStamped } from './index.h'

import { A, flow } from '@mobily/ts-belt'
import { combine, createEvent, createStore, sample } from 'effector'
import { model as i18n } from '~/core/i18n'
import { epgDatesModel, isSameDate, toTimestamp } from '~/entities/epg/dates'
import { selectEpgDateModel } from '~/features/epg/dates/select'
import { F } from '~/shared/helpers'
import { translateDate } from './l10n'
import { toStamped } from './lib'

// generate dates list
export const init = createEvent<{ query: URLSearchParams }>()

// reset widget on epg page left
export const left = createEvent()

// reset widget on sign out
export const reset = createEvent()

// select date
export const select = selectEpgDateModel.setActive

// currently selected date
export const $selected = selectEpgDateModel.$active

// dates list
export const $list = createStore<EpgDateExStamped[]>([])

// pipe to check if date is selected
export const $isDateSelectedPipe = combine($selected, (selected) =>
  selected ? isSameDate(selected) : F
)

// init dates entity
sample({
  clock: init,
  target: epgDatesModel.init,
})

// select initially active date
sample({
  clock: init,
  target: selectEpgDateModel.autoSetActive,
})

// update dates list with respect to initially selected date
sample({
  clock: [init, i18n.$t, selectEpgDateModel.$initial, epgDatesModel.$week],
  source: {
    i18n: i18n.$t,
    initial: selectEpgDateModel.$initial,
    week: epgDatesModel.$week,
  },
  fn: ({ i18n: { t }, initial, week }) => {
    let list = week
    if (initial != null) {
      list = A.append(list, initial)
    }
    list = A.sortBy(A.uniqBy(list, toTimestamp), toTimestamp)
    return A.map(list, flow(translateDate(t), toStamped))
  },
  target: $list,
})

//
// left and reset logic
//

// do nothing
// dates for different users are the same, so,
// no need to reset them on left and/or reset
